import Form from './form.vue';
import FormItem from './form-item.vue';

Form.Item = FormItem;
export default Form;



// WEBPACK FOOTER //
// ./src/components/form/index.js